(() => {
  /*
   * 更新顶部：Shop X selected styles.
   */
  const updateDescriptionCount = (count) => {
    document
      .querySelectorAll('[data-product-count-value]')
      .forEach((element) => {
        element.textContent = count;
      });
  };

  /*
   * Liquid 已将 Shopify Tag 转为 handle 格式。
   * 这里统一处理后台传入值的空格与大小写。
   */
  const normalizeTag = (value) => {
    return (value || '').trim().toLowerCase();
  };

  const getProductTags = (product) => {
    return new Set(
      (product.dataset.productTags || '')
        .split(',')
        .map(normalizeTag)
        .filter(Boolean)
    );
  };

  const initSelectedProducts = (root) => {
    if (!root || root.dataset.selectedProductsReady === 'true') {
      return;
    }

    const grid = root.querySelector('[data-selected-products-grid]');

    const products = Array.from(
      root.querySelectorAll('.selected-products__item')
    );

    const filterButtons = Array.from(
      root.querySelectorAll('[data-tag-filter]')
    );

    const filterDots = Array.from(
      root.querySelectorAll('[data-filter-dot]')
    );

    const featureSelect = root.querySelector('[data-feature-filter]');
    const sortSelect = root.querySelector('[data-product-sort]');
    const resetButton = root.querySelector('[data-reset-filters]');
    const emptyMessage = root.querySelector('[data-filter-empty]');
    const productCount = root.querySelector('[data-product-count]');
    const emptyResetButton = root.querySelector('[data-empty-reset]');
    const loadMoreContainer = root.querySelector(
      '[data-load-more-container]'
    );
    const loadMoreButton = root.querySelector('[data-load-more]');

    if (!grid) {
      updateDescriptionCount(0);
      return;
    }

    products.forEach((product) => {
      product.selectedProductTags = getProductTags(product);
    });

    const allStylesButton =
      filterButtons.find((button) =>
        button.hasAttribute('data-all-filter')
      ) || filterButtons[0] || null;

    let activeFilterButton = allStylesButton;

    /*
     * 记录捆绑模块原来的位置。
     * All styles / Fleece Items 时将同一个模块移动到第 2 个可见产品后面，
     * 其他筛选状态再恢复到原来的位置，避免复制弹框和加购事件。
     */
    const inlineBundle = document.querySelector(
      '[data-inline-winter-bundle]'
    );
    let inlineBundleMarker = null;
    let inlineBundleSlot = null;

    if (inlineBundle) {
      inlineBundleMarker = document.createComment(
        'winter-bundle-original-position'
      );
      inlineBundle.parentNode.insertBefore(
        inlineBundleMarker,
        inlineBundle
      );

      inlineBundleSlot = document.createElement('li');
      inlineBundleSlot.className = 'selected-products__bundle-slot';
      inlineBundleSlot.setAttribute(
        'data-selected-products-bundle-slot',
        ''
      );
    }

    let activeButtonTag = allStylesButton
      ? normalizeTag(allStylesButton.dataset.tagFilter)
      : null;
    let activeFeatureTag = null;
    const productsPerPage = 16;
    let visibleLimit = productsPerPage;

    /*
     * 让筛选按钮与下方圆点保持相同的激活状态。
     */
    const syncFilterDots = (activeButton) => {
      filterDots.forEach((dot, index) => {
        const isActive = filterButtons[index] === activeButton;

        dot.setAttribute('aria-pressed', String(isActive));
        dot.classList.toggle('is-active', isActive);
      });
    };

    /*
     * 产品价格排序。
     */
    const sortProducts = () => {
      const sortValue = sortSelect ? sortSelect.value : 'featured';
      const sortedProducts = [...products];

      sortedProducts.sort((productA, productB) => {
        const priceA = Number(productA.dataset.productPrice || 0);
        const priceB = Number(productB.dataset.productPrice || 0);
        const positionA = Number(productA.dataset.originalPosition || 0);
        const positionB = Number(productB.dataset.originalPosition || 0);

        if (sortValue === 'low') {
          return priceA - priceB;
        }

        if (sortValue === 'high') {
          return priceB - priceA;
        }

        return positionA - positionB;
      });

      sortedProducts.forEach((product) => {
        grid.appendChild(product);
      });

      return sortedProducts;
    };

    const updateInlineBundlePosition = (sortedProducts) => {
      if (
        !inlineBundle ||
        !inlineBundleMarker ||
        !inlineBundleSlot
      ) {
        return;
      }

      const activeFilterKey = normalizeTag(
        activeFilterButton?.dataset.filterKey
      );

      const shouldPlaceInsideGrid =
        activeFilterButton === allStylesButton ||
        activeFilterKey === 'fleece';

      const visibleProducts = sortedProducts.filter(
        (product) => !product.hidden
      );

      if (
        shouldPlaceInsideGrid &&
        visibleProducts.length >= 2
      ) {
        const secondVisibleProduct = visibleProducts[1];

        if (inlineBundle.parentNode !== inlineBundleSlot) {
          inlineBundleSlot.appendChild(inlineBundle);
        }

        grid.insertBefore(
          inlineBundleSlot,
          secondVisibleProduct.nextSibling
        );
        return;
      }

      if (inlineBundleMarker.parentNode) {
        inlineBundleMarker.parentNode.insertBefore(
          inlineBundle,
          inlineBundleMarker.nextSibling
        );
      }

      inlineBundleSlot.remove();
    };

    /*
    * M端两列商品的 custom labels 对齐
    *
    * 两个都有标签：正常
    * 一个有一个没有：没有的补占位
    * 两个都没有：全部不占位
    */
    const syncMobileCustomLabelSpacing = (sortedProducts) => {
      // 每次筛选 / 排序后先清除旧状态
      sortedProducts.forEach((product) => {
        product.classList.remove('mobile-needs-custom-label-space');
      });

      // 只判断当前真正显示的商品
      const visibleProducts = sortedProducts.filter(
        (product) => !product.hidden
      );

      // M端两列，每两个商品为一行
      for (let index = 0; index < visibleProducts.length; index += 2) {
        const leftProduct = visibleProducts[index];
        const rightProduct = visibleProducts[index + 1];

        // 最后一行只有一个商品，不需要补
        if (!leftProduct || !rightProduct) {
          continue;
        }

        // 判断是否存在真正的 custom labels
        // 排除我们自己生成的 placeholder
        const leftHasLabels = Boolean(
          leftProduct.querySelector(
            '.product-card__custom-labels:not(.product-card__custom-labels--pc-placeholder) .product-card__custom-label'
          )
        );

        const rightHasLabels = Boolean(
          rightProduct.querySelector(
            '.product-card__custom-labels:not(.product-card__custom-labels--pc-placeholder) .product-card__custom-label'
          )
        );

        /*
        * 两个都有 / 两个都没有
        * 都不需要额外处理
        */
        if (leftHasLabels === rightHasLabels) {
          continue;
        }

        // 左边没有，右边有
        if (!leftHasLabels && rightHasLabels) {
          leftProduct.classList.add(
            'mobile-needs-custom-label-space'
          );
        }

        // 左边有，右边没有
        if (leftHasLabels && !rightHasLabels) {
          rightProduct.classList.add(
            'mobile-needs-custom-label-space'
          );
        }
      }
    };

    /*
     * 同时应用动态按钮 Tag 与下拉选项 Tag。
     * 两个筛选同时启用时，产品必须同时拥有两个 Tag。
     */
    const applyFilters = (resetVisibleLimit = false) => {
      if (resetVisibleLimit) {
        visibleLimit = productsPerPage;
      }

      let matchedCount = 0;
      const sortedProducts = sortProducts();

      sortedProducts.forEach((product) => {
        const productTags = product.selectedProductTags;

        const matchesButton =
          !activeButtonTag || productTags.has(activeButtonTag);

        const matchesFeature =
          !activeFeatureTag || productTags.has(activeFeatureTag);

        const matchesFilters = matchesButton && matchesFeature;

        if (matchesFilters) {
          matchedCount += 1;
        }

        const shouldShow =
          matchesFilters && matchedCount <= visibleLimit;

        product.hidden = !shouldShow;
      });

      /* M端根据当前一行两个商品动态决定是否需要 labels 占位 */
      syncMobileCustomLabelSpacing(sortedProducts);

      updateInlineBundlePosition(sortedProducts);

      if (productCount) {
        productCount.textContent = `${matchedCount} ${
          matchedCount === 1 ? 'style' : 'styles'
        }`;
      }

      updateDescriptionCount(matchedCount);

      if (emptyMessage) {
        emptyMessage.hidden = matchedCount !== 0;
      }

      if (loadMoreContainer) {
        loadMoreContainer.hidden =
          matchedCount <= visibleLimit || matchedCount <= productsPerPage;
      }
    };

    /*
    * 当前筛选按钮只有在超出可视区域时才滚动。
    * 不再强制居中，避免按钮前后出现大量空白。
    */
    const scrollFilterIntoView = (button) => {
      if (!button) return;

      const filtersContainer = button.closest('.filters');
      if (!filtersContainer) return;

      if (filtersContainer.scrollWidth <= filtersContainer.clientWidth) {
        return;
      }

      requestAnimationFrame(() => {
        const containerRect = filtersContainer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        // 左侧预留一点自然间距
        const edgeGap = 8;

        // 按钮左边超出可视区域
        if (buttonRect.left < containerRect.left + edgeGap) {
          filtersContainer.scrollBy({
            left: buttonRect.left - containerRect.left - edgeGap,
            behavior: 'smooth'
          });
          return;
        }

        // 按钮右边超出可视区域
        if (buttonRect.right > containerRect.right - edgeGap) {
          filtersContainer.scrollBy({
            left: buttonRect.right - containerRect.right + edgeGap,
            behavior: 'smooth'
          });
        }
      });
    };

    /*
     * Reset filters 与 SHOW ALL STYLES 共用。
     */
    const resetAllFilters = () => {
      activeFilterButton = allStylesButton;
      activeButtonTag = allStylesButton
        ? normalizeTag(allStylesButton.dataset.tagFilter)
        : null;
      activeFeatureTag = null;
      filterButtons.forEach((button) => {
        const isAllButton = button === allStylesButton;

        button.setAttribute('aria-pressed', String(isAllButton));
        button.classList.toggle('is-active', isAllButton);
      });

      syncFilterDots(allStylesButton);

      if (featureSelect) {
        featureSelect.value = 'all';
      }

      if (sortSelect) {
        sortSelect.value = 'featured';
      }

      applyFilters(true);
      scrollFilterIntoView(allStylesButton);
    };

    /*
     * 动态分类筛选按钮。
     */
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilterButton = button;
        const selectedTag = normalizeTag(
          button.dataset.tagFilter
        );

        activeButtonTag =
          !selectedTag || selectedTag === 'all'
            ? null
            : selectedTag;

        filterButtons.forEach((item) => {
          const isActive = item === button;

          item.setAttribute(
            'aria-pressed',
            String(isActive)
          );

          item.classList.toggle(
            'is-active',
            isActive
          );
        });

        syncFilterDots(button);

        /*
        * 筛选产品。
        */
        applyFilters(true);

        /*
        * 将刚刚激活的按钮自动滚动到横向列表中间。
        */
        scrollFilterIntoView(button);
      });
    });

    /*
     * 点击圆点时复用对应筛选按钮的完整点击逻辑。
     */
    filterDots.forEach((dot, index) => {
      const targetButton = filterButtons[index];

      if (!targetButton) return;

      dot.addEventListener('click', () => {
        targetButton.click();
      });
    });

    /*
     * Must-have feature 下拉筛选。
     */
    if (featureSelect) {
      featureSelect.addEventListener('change', () => {
        const selectedTag = normalizeTag(featureSelect.value);

        activeFeatureTag =
          !selectedTag || selectedTag === 'all' ? null : selectedTag;

        applyFilters(true);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        applyFilters(true);
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', resetAllFilters);
    }

    if (emptyResetButton) {
      emptyResetButton.addEventListener('click', resetAllFilters);
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        if (loadMoreButton.classList.contains('is-loading')) {
          return;
        }

        loadMoreButton.classList.add('is-loading');
        loadMoreButton.disabled = true;
        loadMoreButton.setAttribute('aria-busy', 'true');

        requestAnimationFrame(() => {
          window.setTimeout(() => {
            visibleLimit += productsPerPage;
            applyFilters();

            loadMoreButton.classList.remove('is-loading');
            loadMoreButton.disabled = false;
            loadMoreButton.removeAttribute('aria-busy');
          }, 350);
        });
      });
    }

    root.dataset.selectedProductsReady = 'true';

    filterButtons.forEach((button) => {
      const isActive = button === allStylesButton;

      button.setAttribute('aria-pressed', String(isActive));
      button.classList.toggle('is-active', isActive);
    });

    syncFilterDots(allStylesButton);
    applyFilters();
  };

  const initAllSelectedProducts = (scope = document) => {
    scope
      .querySelectorAll('[data-selected-products]')
      .forEach(initSelectedProducts);
  };

  /*
   * 顶部快捷入口通过 filter_key 找到对应动态筛选按钮。
   */
  const initShortcutFilters = (scope = document) => {
    scope
      .querySelectorAll(
        '.best-sellers-shortcuts .shortcut[data-jump], ' +
          '.winter-edit-component .path[data-jump], ' +
          '.winter-layer-guide-component a[data-jump]'
      )
      .forEach((shortcut) => {
        if (shortcut.dataset.shortcutFilterReady === 'true') {
          return;
        }

        shortcut.addEventListener('click', (event) => {
          const filterKey = normalizeTag(shortcut.dataset.jump);

          if (!filterKey) return;

          const productSection = document.querySelector(
            '[data-selected-products]'
          );

          if (!productSection) return;

          const targetButton = Array.from(
            productSection.querySelectorAll('[data-filter-key]')
          ).find((button) => {
            return normalizeTag(button.dataset.filterKey) === filterKey;
          });

          if (!targetButton) {
            console.warn(
              `[Selected products] 找不到 data-filter-key="${filterKey}" 的筛选按钮`
            );
            return;
          }

          event.preventDefault();
          targetButton.click();

          requestAnimationFrame(() => {
            const toolbar =
              productSection.querySelector('.toolbar') ||
              productSection.querySelector('.filters') ||
              productSection;

            const navigationOffset = window.innerWidth <= 768 ? 350 : 280;

            const targetTop =
              toolbar.getBoundingClientRect().top +
              window.pageYOffset -
              navigationOffset;

            window.scrollTo({
              top: targetTop,
              behavior: 'smooth'
            });
          });
        });

        shortcut.dataset.shortcutFilterReady = 'true';
      });
  };

  const syncDescriptionCount = () => {
    const productSection = document.querySelector('[data-selected-products]');

    if (!productSection) return;

    const products = Array.from(
      productSection.querySelectorAll('.selected-products__item')
    );

    const visibleCount = products.filter(
      (product) => !product.hidden
    ).length;

    updateDescriptionCount(visibleCount);
  };

  /*
   * LOAD MORE 跳转链接：
   * 默认不显示 spinner；点击后添加 is-loading，
   * 让 CSS 显示转圈，再跳转到链接地址。
   * 使用独立的 data-load-more-link，不影响原有 data-load-more 动态加载逻辑。
   */
  const initLoadMoreLinks = (scope = document) => {
    scope
      .querySelectorAll('[data-load-more-link]')
      .forEach((link) => {
        if (link.dataset.loadMoreLinkReady === 'true') {
          return;
        }

        let loadingTimer = null;

        const stopLoading = () => {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');

          if (loadingTimer) {
            window.clearTimeout(loadingTimer);
            loadingTimer = null;
          }
        };

        const startLoading = () => {
          /*
          * 每次点击重新开始计时。
          * 防止上一次 timer 继续执行。
          */
          if (loadingTimer) {
            window.clearTimeout(loadingTimer);
          }

          link.classList.add('is-loading');
          link.setAttribute('aria-busy', 'true');

          /*
          * 启动后 2 秒自动关闭 loading。
          */
          loadingTimer = window.setTimeout(() => {
            stopLoading();
          }, 2000);
        };

        link.addEventListener('click', (event) => {
          const href = link.href;

          if (!href) {
            return;
          }

          event.preventDefault();

          /*
          * 每次点击都重新启动 loading。
          */
          startLoading();

          /*
          * 保留你原来的跳转逻辑。
          * 先让浏览器渲染 spinner，再进行跳转。
          */
          requestAnimationFrame(() => {
            window.setTimeout(() => {
              window.location.href = href;
            }, 150);
          });
        });

        link.dataset.loadMoreLinkReady = 'true';
      });
  };

  const initAll = (scope = document) => {
    initAllSelectedProducts(scope);
    initShortcutFilters(scope);
    initLoadMoreLinks(scope);

    requestAnimationFrame(syncDescriptionCount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll();
      },
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();